import { learnerships } from '../data/mockData';
import { ButtonLink } from '../components/ui/Button';

export default function LearnershipsPage() {
  return (
    <>
      <section className="bg-hero-glow">
        <div className="container py-14 lg:py-20">
          <div className="max-w-3xl">
            <span className="eyebrow">Accredited qualifications</span>
            <h1 className="mt-5 text-4xl leading-tight sm:text-5xl">
              MICT SETA learnerships
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-brand-900/65">
              Each learnership runs for 12 months and leads to a SAQA-registered
              national certificate. Below are the qualifications, their modules,
              and what you need to get in.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white">
        <div className="section-shell space-y-8">
          {learnerships.map((course) => (
            <article
              key={course.id}
              id={course.saqaId}
              className="card-surface overflow-hidden scroll-mt-24"
            >
              <div
                className={`bg-gradient-to-r px-6 py-8 sm:px-10 ${course.gradient}`}
              >
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-white/95 px-3 py-1 text-xs font-bold text-brand-800">
                    SAQA {course.saqaId}
                  </span>
                  {course.nqfLevel && (
                    <span className="rounded-full bg-brand-950/30 px-3 py-1 text-xs font-semibold text-white backdrop-blur">
                      NQF Level {course.nqfLevel}
                    </span>
                  )}
                  <span className="rounded-full bg-brand-950/30 px-3 py-1 text-xs font-semibold text-white backdrop-blur">
                    {course.durationMonths} months
                  </span>
                  {course.credits && (
                    <span className="rounded-full bg-brand-950/30 px-3 py-1 text-xs font-semibold text-white backdrop-blur">
                      {course.credits} credits
                    </span>
                  )}
                </div>
                <h2 className="mt-4 max-w-2xl text-2xl text-white sm:text-3xl">
                  {course.title}
                </h2>
              </div>

              <div className="p-6 sm:p-10">
                <p className="max-w-3xl text-base leading-relaxed text-brand-900/70">
                  {course.summary}
                </p>

                {(course.modules.length > 0 ||
                  course.entryRequirements.length > 0) && (
                  <div className="mt-8 grid gap-8 lg:grid-cols-2">
                    {course.modules.length > 0 && (
                      <div>
                        <h3 className="text-sm font-bold uppercase tracking-wider text-brand-600">
                          Modules
                        </h3>
                        <ul className="mt-4 space-y-2.5">
                          {course.modules.map((module) => (
                            <li
                              key={module}
                              className="flex items-start gap-3 text-sm text-brand-900/75"
                            >
                              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-400" />
                              {module}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {course.entryRequirements.length > 0 && (
                      <div>
                        <h3 className="text-sm font-bold uppercase tracking-wider text-brand-600">
                          Entry requirements
                        </h3>
                        <ul className="mt-4 space-y-2.5">
                          {course.entryRequirements.map((req) => (
                            <li
                              key={req}
                              className="flex items-start gap-3 text-sm text-brand-900/75"
                            >
                              <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                                <svg
                                  className="h-2.5 w-2.5"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  aria-hidden="true"
                                >
                                  <path d="m4 12 5 5L20 6" />
                                </svg>
                              </span>
                              {req}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}

                {course.modules.length === 0 && (
                  <p className="mt-6 rounded-2xl bg-canvas-100 p-4 text-sm text-brand-900/60">
                    Full module breakdown and entry requirements for this
                    qualification are available on request.
                  </p>
                )}

                <ButtonLink to="/apply" variant="primary" size="md" className="mt-8">
                  Apply for this programme
                </ButtonLink>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
